import {
	ChangeDetectionStrategy,
	Component,
	HostBinding,
	inject,
	input,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TuiSizeXL, TuiSizeXS } from '@taiga-ui/core';
import { MarmonIcons, MarmonIconType } from './icons.const';

@Component({
	standalone: true,
	imports: [],
	selector: 'mar-icon',
	template: `<span [innerHtml]="icon"></span>`,
	styleUrl: './icon.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
	readonly sanitizer = inject(DomSanitizer);

	readonly name = input<MarmonIconType>();

	readonly size = input<TuiSizeXL | TuiSizeXS>('m');

	@HostBinding('attr.size')
	get attrSize() {
		return this.size();
	}

	get icon() {
		const value = this.name();
		if (!value) {
			console.warn('Icon name was not provided');
			return null;
		}

		return this.sanitizer.bypassSecurityTrustHtml(MarmonIcons[value]);
	}
}
